// ANDREA – GIFT-GOAL.JS

class GiftGoal extends HTMLElement {
  constructor() {
    super();

    /* ───── CONFIG ───── */
    this.thresholds = JSON.parse(this.dataset.thresholds || "[]").map(
      (v) => v * (window.Shopify?.currency?.rate || 1)
    );
    this.progressBar = this.querySelector("progress-bar");
    this.steps = [...this.querySelectorAll(".progress-step")];
    this.moneyFormat =
      window.FoxTheme?.settings?.moneyFormat ||
      "{{amount_no_decimals_with_comma_separator}}€";

    /* pallini al 33-66-100 % */
    this.positionSteps();

    /* osserva cambi di dimensione del contenitore */
    this._resizeObs = new ResizeObserver(() => this.positionSteps());
    this._resizeObs.observe(this.querySelector(".gift-goal__progress-steps"));

    /* init con totale server-side */
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Funzione per calcolare la somma delle quantità degli item non-gift card
        let totalLinePrice = 0;
        let isGiftCard = false;

        cart.items.forEach((item) => {
          // Verifica se l'item NON è una gift card e somma la quantità
          // Controlliamo anche se gift_card è undefined (consideriamo come non gift card)
          if (item.gift_card == true) {
            isGiftCard = true;
            console.log(
              `✅ Trovata gift card: ${item.quantity} unità di ${item.title}`
            );
          }
        });

        if (isGiftCard) {
          this.update(0);
        } else {
          this.update(Number(this.dataset.cartTotal));
        }
      })
      .catch((error) => {
        this.update(Number(this.dataset.cartTotal)); // fallback

        console.error("Errore nel recupero del carrello:", error);
      });

    /* aggiorna su ogni evento carrello */
    document.addEventListener("cart:updated", (e) => {
      const cart = e.detail.cart;

      // Verifica se c'è almeno una gift card nel carrello
      const hasGiftCard =
        cart.items && cart.items.length
          ? cart.items.some((item) => item.gift_card === true)
          : false;

      // Se c'è almeno una gift card, ritorna 0
      if (hasGiftCard) {
        this.update(0);
        return;
      }

      // Calcola il totale pagato, escludendo solo prodotti a prezzo zero
      const paidTotal =
        cart.items && cart.items.length
          ? cart.items
              .filter(
                (item) =>
                  // Escludi solo prodotti a prezzo zero
                  (item.final_line_price ?? item.price * item.quantity) > 0
              )
              .reduce(
                (sum, item) =>
                  sum + (item.final_line_price ?? item.price * item.quantity),
                0
              )
          : 0;

      this.update(paidTotal);
    });
  }

  /* posizionamento pallini equidistanti 33-66-100 */
  positionSteps() {
    const total = this.steps.length; // 3
    this.steps.forEach((step, idx) => {
      const percent = ((idx + 1) / total) * 100; // 33.3
      step.style.left = `${percent}%`;
    });
  }

  /* aggiorna barra, pallini e messaggi */
  update(amountCents) {
    const amount = amountCents / 100;
    console.log("GiftGoal update with amount:", amount);
    /* mostra/nascondi blocco */
    this.classList.toggle("hidden", amount <= 0);
    if (amount <= 0) return;

    /* pallini attivi */
    const reached = this.thresholds.filter((t) => amount >= t).length; // 0–3
    this.steps.forEach((s, i) => s.classList.toggle("is-active", i < reached));

    /* percentuale barra (33 % per segmento) */
    const segSize = 100 / this.thresholds.length; // 33.333…
    let segIndex = this.thresholds.findIndex((t) => amount < t);
    if (segIndex === -1) segIndex = this.thresholds.length; // oltre ultima soglia

    const startVal = segIndex === 0 ? 0 : this.thresholds[segIndex - 1];
    const endVal =
      segIndex === this.thresholds.length
        ? this.thresholds[this.thresholds.length - 1]
        : this.thresholds[segIndex];
    const withinSeg =
      segIndex === this.thresholds.length
        ? 1
        : (amount - startVal) / (endVal - startVal);
    const percent = Math.min(100, segIndex * segSize + withinSeg * segSize);

    this.progressBar.style.setProperty("--percent", `${percent}%`);
    this.progressBar.dataset.value = amount;
    this.progressBar.dataset.max = this.thresholds[this.thresholds.length - 1];

    /* messaggio “ti mancano …” */
    const msg = this.querySelector("[data-left-to-spend]");
    if (msg) {
      const nextGoal =
        segIndex < this.thresholds.length
          ? this.thresholds[segIndex]
          : this.thresholds[this.thresholds.length - 1];
      const left = Math.max(0, nextGoal - amount) * 100; // centesimi
      msg.innerHTML = FoxTheme.Currency.formatMoney(left, this.moneyFormat);
    }

    /* stato completato */
    const done = reached >= this.thresholds.length;
    this.classList.toggle("gift-goal--done", done);
    this.classList.toggle("free-shipping-goal--done", done);
  }

  /* pulizia observer se il nodo viene rimosso */
  disconnectedCallback() {
    this._resizeObs?.disconnect();
  }
}

/* registra custom-element se non presente */
if (!customElements.get("gift-goal")) {
  customElements.define("gift-goal", GiftGoal);
}
